import React, { useContext } from "react";
import { Box, Typography, Button } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useNavigate } from "react-router-dom";
import {
  PORTAL_PREFIX,
  PAGE_PORTAL_ORDERS_SALES_LIST,
  KivuI18nContext,
  localizedPath,
  useKivunovaTranslation
} from "@kivunova/kivufrontendcommon";

const NoSalesOrderDetailFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useKivunovaTranslation();
  const { language, defaultLang } = useContext(KivuI18nContext) || {};

  return (
    <Box
      sx={{
        p: 5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "70vh",
        color: "black"
      }}
    >
      <Typography color="textPrimary" variant="h5" fontWeight="bold" mb={2}>
        {t("sales-order-not-found", "Sales Order not found")}
      </Typography>
      <Typography color="text.secondary" mb={3}>
        {t(
          "sales-order-not-found-description",
          "The sales order you're looking for doesn't exist or has been removed."
        )}
      </Typography>
      <Button
        variant="contained"
        startIcon={<ArrowBackOutlinedIcon />}
        onClick={() =>
          navigate(
            localizedPath(
              `/${PORTAL_PREFIX}/${PAGE_PORTAL_ORDERS_SALES_LIST}`,
              language,
              defaultLang
            )
          )
        }
      >
        {t("back-to-sales-order-list", "Back to Sales Order List")}
      </Button>
    </Box>
  );
};

export default NoSalesOrderDetailFound;
